import { THEME } from '@lyon/utils/theme';
import { BlockOverrides } from 'baseui/block';
import { TagOverrides } from 'baseui/tag';
import { StyleObject } from 'styletron-react';

export const H1: BlockOverrides = {
  Block: {
    style: {
      fontSize: '36px',
      fontWeight: 'bold',
      lineHeight: '1.15',
      marginBottom: '12px',
    },
  },
};

export const H2: BlockOverrides = {
  Block: {
    style: {
      fontSize: '22px',
      fontWeight: 600,
      lineHeight: '1.15',
      marginBottom: '28px',
    },
  },
};

const NORMAL_BASE: StyleObject = {
  fontSize: '14px',
  lineHeight: 1.75,
  fontWeight: 400,
  whiteSpace: 'pre-wrap',
};

export const PURPLE: BlockOverrides = {
  Block: {
    style: {
      color: THEME.colors.primary400,
      fontWeight: 700,
      fontSize: '14px',
      alignItems: 'center',
      display: 'flex',
    },
  },
};

export const NORMAL: BlockOverrides = {
  Block: {
    style: NORMAL_BASE,
  },
};

export const NORMAL_FADED: BlockOverrides = {
  Block: {
    style: {
      ...NORMAL_BASE,
      maxHeight: '192px',
      overflow: 'hidden',
      content: '',
      background: 'linear-gradient(#fff 60%, transparent)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    },
  },
};

export const HEADER_GRID: BlockOverrides = {
  Block: {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      alignItems: 'flex-start',

      [THEME.media.large]: {
        gridTemplateColumns: '1fr auto',
        gridColumnGap: '64px',
      },
    },
  },
};

export const HEADER_TAGS: BlockOverrides = {
  Block: {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginBottom: '24px',

      [THEME.media.large]: {
        marginBottom: '16px',
      },
    },
  },
};

export const HEADER_TAG: TagOverrides = {
  Root: {
    style: {
      backgroundColor: THEME.colors.darkmuted500,
      height: '28px',
      paddingLeft: '32px',
      paddingRight: '32px',
      marginRight: '8px',
      marginLeft: 0,
    },
  },
  Text: {
    style: {
      fontSize: '12px',
      color: THEME.colors.primaryA,
      opacity: 0.8,
      maxWidth: 'inherit',
      overflowX: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
};

export const HEADER_CONTAINER: BlockOverrides = {
  Block: {
    style: {
      borderLeftStyle: 'solid',
      borderRightStyle: 'solid',
      borderBottomStyle: 'solid',
      borderTopWidth: 0,
      borderLeftWidth: '1px',
      borderRightWidth: '1px',
      borderBottomWidth: '1px',
      borderBottomColor: THEME.colors.darkmuted50,
      borderLeftColor: THEME.colors.darkmuted50,
      borderRightColor: THEME.colors.darkmuted50,
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
      paddingTop: '40px',
      paddingBottom: '24px',
      paddingLeft: '6vw',
      paddingRight: '6vw',

      [THEME.media.large]: {
        paddingLeft: '3vw',
        paddingRight: '3vw',
        borderBottomRightRadius: '4px',
        borderBottomLeftRadius: '4px',
      },
    },
  },
};

export const FOOTER: BlockOverrides = {
  Block: {
    style: {
      marginLeft: '24px',
      marginRight: '24px',

      [THEME.media.large]: {
        marginLeft: 0,
        marginRight: 0,
      },
    },
  },
};
